module.exports = __webpack_public_path__ + "static/media/7-二合一根管预备机Plus.28d7f7f8.jpg";